var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.5,
    height: 80.1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#f64c71}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M26.8 18.9c5.2 0 9.4-4.2 9.4-9.4S32 0 26.8 0s-9.4 4.2-9.4 9.4 4.2 9.5 9.4 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M42.4 41.7H11.2l-5.1 18c-.1.4 0 .8.2 1.2.2.3.7.5 1.1.5h9.9l2.6 17.5c.1.7.7 1.1 1.4 1.1h11.3c.7 0 1.3-.5 1.4-1.1l2.6-17.5h9.6c.4 0 .8-.2 1.1-.5.2-.3.4-.8.2-1.2l-5.1-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M53.4 43.1l-5.7-16.6C46.4 22.6 43 20 39.2 20H14.4c-3.8 0-7.2 2.6-8.5 6.5L.2 43.1c-.2.7-.2 1.4.1 2 .3.7.7 1.1 1.4 1.4.3.1.6.2.9.2 1 0 1.9-.7 2.3-1.7l5.7-16.6c.6-1.8 2.2-3 3.9-3h1.2l-1.1 4.9s0 .1-.1.1L11.7 40h30.2l-2.7-9.6s0-.1-.1-.1l-1.1-5h1.2c1.7 0 3.3 1.2 3.9 3L48.8 45c.5 1.4 1.9 2 3.1 1.6.6-.2 1.1-.7 1.4-1.4.3-.7.3-1.4.1-2.1zM39.2 22.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.ce0008366e6dfcf15a85d85c8acac018.svg";
export { ForwardRef as ReactComponent };